import { render } from "./StoreEventNoteCreateModal.vue?vue&type=template&id=4f2ff74b"
import script from "./StoreEventNoteCreateModal.vue?vue&type=script&lang=js"
export * from "./StoreEventNoteCreateModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__